export enum StoreKeysEnum {
    APP = 'appState',
    SYSTEM = 'system',
    USER = 'user',
}

export enum StoreKeysMainEnum {
    SETTINGS = 'settings',
    DEVICE_ID = 'deviceId',
    DEVICE_INFO = 'deviceInfo',
    NOTIFICATION_TOKEN = 'notificationToken',
    APP_STATE = 'appState',
    USER_DATA = 'userData',
}

export enum StoreKeysSubEnum {
    ACCESS_TOKEN = 'accessToken',
    REFRESH_TOKEN = 'refreshToken',
    BIOMENTRIC = 'isBiometric',
    BIOMENTRICS_TYPE = 'isBiometricsType',
    AUTO_REFRESH = 'isAutorefresh',
    NOTIFICATIONS = 'notifications',
    AVAILABLE_NOTIFICATION_PERMISSION = 'isAvailableNotificationPermission',
    NEED_SEND_TOKEN = 'isNeedSendToken',
    APP_LANG = 'appLang',
    APP_LANG_SET_USER = 'appLangSetUser',
    COLOR_SCHEME = 'colorScheme',
    CURRENT_MODULE = 'currentModule',
}
